import styled from 'styled-components';
import { LeaderboardWidgetUI } from '../Leaderboard/LeaderboardWidgetUI';
import { TeamSecuritySnapshotUI } from '../TeamSecuritySnapshot/TeamSecuritySnapshotUI';
import { ManagerTeamTrainingWidget } from '../Activity/ManagerTeamTrainingWidget';
import { CardErrorView } from '../ErrorView/CardErrorView';
import { withErrorBoundaries } from '../../lib/decorators/withErrorBoundaries';
import { TeamBehaviorsUI } from '../TeamBehaviors/TeamBehaviorsUI';
import { TeamMembers } from '../TeamBehaviors/components/TeamMembers';

export const ManagerOverview: React.FC = () => {
  const {
    LeaderboardWidgetUI_WithErrorBoundary,
    TeamSecuritySnapshotUI_WithErrorBoundary,
    ManagerTeamTrainingWidget_WithErrorBoundary,
    TeamBehaviorsUI_WithErrorBoundary,
    TeamMembers_WithErrorBoundary,
  } = withErrorBoundaries(
    {
      LeaderboardWidgetUI,
      TeamSecuritySnapshotUI,
      ManagerTeamTrainingWidget,
      TeamBehaviorsUI,
      TeamMembers,
    },
    CardErrorView,
  );

  return (
    <PageFrame>
      <PageHero />
      <PageFade />
      <PageContent>
        <Layout>
          <Column>
            <TeamSecuritySnapshotUI_WithErrorBoundary />
            <TeamBehaviorsUI_WithErrorBoundary />
            <TeamMembers_WithErrorBoundary />
          </Column>
          <Column>
            <LeaderboardWidgetUI_WithErrorBoundary isManager />
            <ManagerTeamTrainingWidget_WithErrorBoundary />
          </Column>
        </Layout>
      </PageContent>
    </PageFrame>
  );
};

const PageFrame = styled.div`
  position: relative;
  margin-top: calc(-1 * var(--layout-offset-top));
  margin-bottom: calc(-1 * var(--layout-offset-bottom));
  margin-left: calc(50.5% - 50vw);
  margin-right: calc(50.5% - 50vw);
  min-height: calc(100vh - 64px);
  overflow: hidden;
  background: ${({ theme }) => theme.colors.bodyBackground};
`;

const PageHero = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 440px;
  background-image: url('/branding/background.png');
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.82;
`;

const PageFade = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 440px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 36%,
    rgba(255, 255, 255, 0.72) 72%,
    ${({ theme }) => theme.colors.bodyBackground} 88%
  );
`;

const PageContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1440px;
  margin: 0 auto;
  padding: 142px 16px 36px;

  @media (max-width: 768px) {
    padding: 72px 16px 20px;
  }
`;

const Layout = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1fr) 340px;
  min-height: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;
